$(document).ready(function () {
    if ($('.sticky-scroll-box').length) {
        var $window = $(window),
            $stickyEl = $('.sticky-scroll-box'),
            elTop = $stickyEl.offset().top;

        $window.scroll(function () {
            $stickyEl.toggleClass('fixed', $window.scrollTop() > elTop);
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/partials/sub-nav.js
// module id = 35
// module chunks = 0